<div class="content-wrapper" style="min-height: 368px">
  <div class="pt-2 pb-2">
    <div class="card m-2">
      <div class="card-body" style="padding: 5px;">
        <h3 class="underline">Contact Us</h3>
          <ul class="social-icons p-0 m-0">
            <!-- <li><a class="panel" href="https://wa.me/91" target="_blank"><img src="/assets/icons/wa.svg" alt="Whatsapp Icon"></a></li> -->
            <li><a href="javascript:void(0)" target=""><img src="/assets/icons/tg.svg" alt="Telegram Icon"></a></li>
            <li><a href="javascript:void(0)" target=""><img src="/assets/icons/ig.svg" alt="Instagram Icon"></a></li>
            <li><a href="javascript:void(0)" target=""><img src="/assets/icons/fb.svg" alt="Facebook Icon"></a></li>
          </ul>
          <p class="mt-4">EmailId : <a href="mailto:support@100xwins.com">support@100xwins.com</a></p>
      </div>
    </div>
  </div>
</div>
